import React from 'react';
import PageBody from '../../components/pagebody/PageBody';
import { Navigate, Route, Routes } from 'react-router-dom';
import ManageUsers from './manageusers/ManageUsers';
import RightsManagement from './rightsmanagement/RightsManagement';

export default function UsersSection() {
    return (
        <PageBody>
            <Routes>
                <Route path="/manageusers" element={<ManageUsers />} />
                <Route path="/rightsmanagement" element={<RightsManagement />} />
                <Route path={'/*'} element={<Navigate to={`/users/manageusers`} replace={true} />} />
            </Routes>
        </PageBody>
    )
}